const SUPPORTED_LOCALES = new Set(['en-au', 'en-nz']);

function initCurrencySelector() {
    const selector = document.querySelector('#currency-selector');
    if (!selector) {
        return;
    }

    setSelectedOption(selector);

    selector.addEventListener('change', (event) => {
        handleCurrencyChange(event.target.value);
    });
}


function handleCurrencyChange(newLocalePath) {
    if (!newLocalePath) {
        return;
    }

    if (!newLocalePath.startsWith('/')) {
        window.location.href = newLocalePath;
        return;
    }

    const pathSegments = window.location.pathname.split('/').filter(Boolean);

    const currentLocale = pathSegments[0];
    const hasLocaleInPath = SUPPORTED_LOCALES.has(currentLocale);

    const remainingPath = (hasLocaleInPath ? pathSegments.slice(1) : pathSegments).join('/');


    const newPath = newLocalePath === '/'
        ? `/${remainingPath}`
        : `${newLocalePath}/${remainingPath}`;

    window.location.href = newPath;
}


function setSelectedOption(selector) {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    const currentLocale = pathSegments[0];

    if (!SUPPORTED_LOCALES.has(currentLocale)) {
        return;
    }

    const targetValue = `/${currentLocale}`;
    const optionToSelect = Array.from(selector.options).find(opt => opt.value === targetValue);

    if (optionToSelect) {
        optionToSelect.selected = true;
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCurrencySelector);
  } else {
    initCurrencySelector();
  }
